import { Grid } from "@mui/material";
import type { HunterDetailPartyDto } from "Infrastructure/Api/Api";
import { formatPhone } from "Utils/PhoneUtils";
import { Resources, useResource } from "Translations/Resources";
import { GridItem } from "Components/Shared/GridItem";
import { PaperTitle } from "Components/Shared/PaperTitle";

const RESOURCES = Resources.Hunter.HuntersOverview.Detail;

type Props = {
  party: HunterDetailPartyDto;
};

export const ContactInfoSection = ({ party: { phone, email } }: Props) => {
  const { t } = useResource();

  return (
    <>
      <PaperTitle>{t(RESOURCES.ContactInfo)}</PaperTitle>
      <Grid container spacing={2}>
        <GridItem label={t(RESOURCES.Email)} value={email} />
        <GridItem
          label={t(RESOURCES.Phone)}
          value={formatPhone(phone) || undefined}
        />
      </Grid>
    </>
  );
};
